module.exports = __webpack_public_path__ + "static/media/wu-bg-alternate-logo-gray2-mobile2.70677875.svg";